import { render, staticRenderFns } from "./TransactionHub.vue?vue&type=template&id=b54150f0&scoped=true&"
import script from "./TransactionHub.vue?vue&type=script&lang=js&"
export * from "./TransactionHub.vue?vue&type=script&lang=js&"
import style0 from "./TransactionHub.vue?vue&type=style&index=0&id=b54150f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54150f0",
  null
  
)

export default component.exports